import(/* webpackMode: "eager" */ "/codebuild/output/src2291691120/src/LPL_WEB/app/page.js");
